import { useInView } from '@cian/valuation-utils-component';
import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IRecommendationsList {
  onShow?(): void;
  onLoad?(): void;
  children: React.ReactNode;
}

export const RecommendationsList: React.FC<IRecommendationsList> = ({ children, onShow, onLoad }) => {
  const [isShown, setIsShown] = React.useState(false);
  const { isLoaded: isVisitedOffersLoaded } = useVisitedOffersContext();

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onLoad) {
      onLoad();
    }
  }, [inView, onLoad]);

  React.useEffect(() => {
    if (inView && onShow && !isShown && isVisitedOffersLoaded) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown, isVisitedOffersLoaded]);

  return (
    <div ref={ref} className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading2>Могут подойти</UIHeading2>
        <div className={styles['list']}>{children}</div>
      </div>
    </div>
  );
};
